import {
  SetDataKeyValuePair,
  SetDataSelector,
  SetDataFunctionSignatures,
} from '@/shared/models/Transaction'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import { extractSignature } from '@/shared/getFunctionSignature'
import { getSetDataSelector } from '@/shared/getSetDataSelector'

export type DecodedValue = { [key: string]: any }

const decodeSignatureParameters = (
  signature: string,
  payload: string
): DecodedValue => {
  const web3Eth = useWeb3Eth().getWeb3Eth()
  const extract = extractSignature(signature)
  const parameters = extract.params

  return payload.slice(10)
    ? web3Eth.abi.decodeParameters(parameters, payload.slice(10))
    : {}
}

const getDecodedSetData = (
  setDataSignature: SetDataFunctionSignatures,
  data: string
): (SetDataKeyValuePair & SetDataSelector)[] => {
  const parameters = decodeSignatureParameters(setDataSignature, data)
  const setDataSelectors: (SetDataKeyValuePair & SetDataSelector)[] = []
  if (setDataSignature === SetDataFunctionSignatures.BATCH) {
    for (let i = 0; i < parameters[0].length; i++) {
      const setDataKey = parameters[0][i]
      const setDataValue = parameters[1][i]
      setDataSelectors.push(getSetDataSelector(setDataKey, setDataValue))
    }
  } else {
    const setDataKey = parameters[0]
    const setDataValue = parameters[1]
    setDataSelectors.push(getSetDataSelector(setDataKey, setDataValue))
  }
  return setDataSelectors
}

export function useABIDecoder(): {
  getDecodedSetData: (
    setDataSignature: SetDataFunctionSignatures,
    data: string
  ) => (SetDataKeyValuePair & SetDataSelector)[]
  decodeSignatureParams: (signature: string, payload: string) => DecodedValue
} {
  return {
    getDecodedSetData,
    decodeSignatureParams: decodeSignatureParameters,
  }
}
